function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
import React, { PureComponent, createRef } from "react";
import SocialAppHeader from "./SocialAppHeader";
import ErrorBoundary from "./ErrorBoundary";
import Icon from "./Icon";
import RatingComponent from "react-rating";
import classNames from "classnames";
import isEqual from "lodash/isEqual";
import { injectIntl } from "react-intl";
import { CSSTransition } from "react-transition-group";
import { FocusOn } from "react-focus-on";
import eventBus from "../utils/eventBus";
import UIToggleButton from "./ui/UIToggleButton";
var NODE_FILTER_TYPES = {
    CBOOK: "cbook",
    CURRENT_SLIDE: "currentSlide",
    CURRENT_CHAPTER: "currentChapter"
};
var BonusMaterialComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    _inherits(BonusMaterialComponent, PureComponent);
    var _super = _createSuper(BonusMaterialComponent);
    function BonusMaterialComponent(props) {
        _classCallCheck(this, BonusMaterialComponent);
        var _this;
        _this = _super.call(this, props);
        _this.renderBonus = function(bonus) {
            var _bonus_document, _bonus_document1;
            var isRatingAllowed = _this.state.isRatingAllowed;
            var _this_props = _this.props, getSlide = _this_props.getSlide, isCompleted = _this_props.isCompleted, isAvailable = _this_props.isAvailable, intl = _this_props.intl, ratings = _this_props.ratings, notify = _this_props.notify;
            var rating = ratings["bonus".concat((_bonus_document = bonus.document) === null || _bonus_document === void 0 ? void 0 : _bonus_document.id)];
            var slide = getSlide(bonus.owner.id, bonus.owner.type);
            var isVisited = !!slide && isCompleted(slide.id);
            var available = !!slide && isAvailable(slide);
            var slideClasses = classNames("material-item", {
                "chart-status__visited": isVisited,
                "chart-status__not-visited": !isVisited,
                "chart-status__disabled": !available
            });
            return /*#__PURE__*/ React.createElement("li", {
                className: slideClasses,
                key: bonus.id,
                onClick: function() {
                    return !available && notify(slide);
                }
            }, /*#__PURE__*/ React.createElement("div", {
                className: "material-item__data"
            }, /*#__PURE__*/ React.createElement("div", {
                className: "material-item__icon"
            }, bonus.icon ? /*#__PURE__*/ React.createElement("img", {
                src: bonus.icon.url,
                alt: bonus.alt,
                title: bonus.alt
            }) : /*#__PURE__*/ React.createElement(Icon, {
                name: "download-document",
                size: "m"
            })), /*#__PURE__*/ React.createElement("div", {
                className: "material-item__text"
            }, /*#__PURE__*/ React.createElement("div", {
                className: "material-item__alt",
                dangerouslySetInnerHTML: {
                    __html: bonus.alt
                }
            }), /*#__PURE__*/ React.createElement("div", {
                className: "material-item__name",
                dangerouslySetInnerHTML: {
                    __html: bonus.name
                }
            }), isRatingAllowed && /*#__PURE__*/ React.createElement("div", {
                className: "material-item__rating"
            }, /*#__PURE__*/ React.createElement(RatingComponent, {
                initialRating: rating ? rating.average : 0,
                emptySymbol: /*#__PURE__*/ React.createElement(Icon, {
                    name: "star-outline",
                    size: "s",
                    className: "rating-bullet"
                }),
                fullSymbol: /*#__PURE__*/ React.createElement(Icon, {
                    name: "star-fill",
                    size: "s",
                    className: "rating-bullet--full"
                }),
                onChange: function(value) {
                    var _bonus_document;
                    _this._onRating((_bonus_document = bonus.document) === null || _bonus_document === void 0 ? void 0 : _bonus_document.id, value);
                }
            }), /*#__PURE__*/ React.createElement("span", {
                className: "material-item__rating-count"
            }, intl.formatMessage({
                id: "social.rating.ratings",
                defaultMessage: "Rating: {count}"
            }, {
                count: rating ? rating.count : 0
            }))))), available && /*#__PURE__*/ React.createElement("a", {
                href: (_bonus_document1 = bonus.document) === null || _bonus_document1 === void 0 ? void 0 : _bonus_document1.url,
                target: "_blank",
                rel: "noopener noreferrer",
                className: "material-item__indicator",
                "aria-label": intl.formatMessage({
                    id: "social.download",
                    defaultMessage: "Download"
                })
            }, /*#__PURE__*/ React.createElement(Icon, {
                name: "download",
                size: "m"
            })));
        };
        _this._toggleNodeFilter = function(pressed) {
            // INFO: being pressed means searching the whole cbook
            var filter = pressed ? NODE_FILTER_TYPES.CBOOK : NODE_FILTER_TYPES.CURRENT_SLIDE;
            _this._onNodeFilterChanged(filter);
        };
        _this._onNodeFilterChanged = function(filter) {
            var _this_state = _this.state, isRatingAllowed = _this_state.isRatingAllowed, isLoggedIn = _this_state.isLoggedIn;
            var _this_props = _this.props, bonusMaterial = _this_props.bonusMaterial, currentSlideBonus = _this_props.currentSlideBonus, getRating = _this_props.getRating;
            var _m = [];
            switch(filter){
                case NODE_FILTER_TYPES.CURRENT_SLIDE:
                    _m = currentSlideBonus.slice();
                    break;
                case NODE_FILTER_TYPES.CBOOK:
                    _m = bonusMaterial.slice();
                    break;
                default:
                    break;
            }
            if (isLoggedIn && isRatingAllowed) {
                var i = 0;
                while(i < _m.length){
                    var _m_i, _m_i_document;
                    getRating("bonus".concat((_m_i = _m[i]) === null || _m_i === void 0 ? void 0 : (_m_i_document = _m_i.document) === null || _m_i_document === void 0 ? void 0 : _m_i_document.id));
                    i++;
                }
            }
            _this.setState({
                bonusMaterial: _m,
                currentNodeFilter: filter
            });
        };
        _this._onRating = function(bonusId, stars) {
            _this.props.setRating("bonus".concat(bonusId), stars);
        };
        _this._onConfigChange = function() {
            var _this_props = _this.props, socialConfig = _this_props.socialConfig, session = _this_props.session;
            _this.setState({
                isRatingAllowed: !!(socialConfig === null || socialConfig === void 0 ? void 0 : socialConfig.is_rating_allowed),
                isLoggedIn: !!session && !!socialConfig && (!socialConfig.disclaimer.needs_endorsement || socialConfig.disclaimer.needs_endorsement && session.is_disclaimer_endorsed)
            });
        };
        _this._onSessionChanged = function() {
            var _this_props = _this.props, socialConfig = _this_props.socialConfig, session = _this_props.session;
            _this.setState({
                isLoggedIn: !!session && !!socialConfig && (!socialConfig.disclaimer.needs_endorsement || socialConfig.disclaimer.needs_endorsement && session.is_disclaimer_endorsed)
            });
        };
        var socialConfig = props.socialConfig, session = props.session;
        _this.closeButton = /*#__PURE__*/ createRef();
        _this.state = {
            ratings: [],
            currentNodeFilter: NODE_FILTER_TYPES.CURRENT_SLIDE,
            isRatingAllowed: !!(socialConfig === null || socialConfig === void 0 ? void 0 : socialConfig.is_rating_allowed),
            isLoggedIn: !!session && !!socialConfig && (!socialConfig.disclaimer.needs_endorsement || socialConfig.disclaimer.needs_endorsement && session.is_disclaimer_endorsed),
            bonusMaterial: props.currentSlideBonus || []
        };
        return _this;
    }
    var _proto = BonusMaterialComponent.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var close = this.props.close;
        eventBus.register("Escape", "bonus-app", close);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        eventBus.unregister("Escape", "bonus-app");
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
        var _this_props = this.props, visible = _this_props.visible, currentSlideBonus = _this_props.currentSlideBonus, currentOnly = _this_props.currentOnly;
        if (visible !== prevProps.visible) {
            if (visible) {
                this._onNodeFilterChanged(this.state.currentNodeFilter);
                eventBus.setScope("bonus-app");
            } else {
                eventBus.usePrevScope();
            }
        }
        if (currentOnly !== prevProps.currentOnly && currentOnly) {
            this.setState({
                currentNodeFilter: NODE_FILTER_TYPES.CURRENT_SLIDE
            });
        }
        if (!isEqual(currentSlideBonus, prevProps.currentSlideBonus)) {
            this._onNodeFilterChanged(this.state.currentNodeFilter);
        }
    };
    _proto.render = function render() {
        var _this = this;
        var _this_props = this.props, intl = _this_props.intl, visible = _this_props.visible, close = _this_props.close, currentOnly = _this_props.currentOnly;
        var _this_state = this.state, bonusMaterial = _this_state.bonusMaterial, currentNodeFilter = _this_state.currentNodeFilter;
        var showFromAllCBook = currentNodeFilter === NODE_FILTER_TYPES.CBOOK;
        var currentFilter = showFromAllCBook ? intl.formatMessage({
            id: "social.activities._title_nodes_filter_cbook",
            defaultMessage: "cbook"
        }) : intl.formatMessage({
            id: "social.activities._title_nodes_filter_current_chart",
            defaultMessage: "current slide"
        });
        return /*#__PURE__*/ React.createElement(CSSTransition, {
            in: visible,
            timeout: 300,
            classNames: "social-app"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "social-app social-app--bonus",
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": "bonus-material-header"
        }, /*#__PURE__*/ React.createElement(ErrorBoundary, null, /*#__PURE__*/ React.createElement(FocusOn, {
            enabled: visible,
            onActivation: function() {
                var _this_closeButton, _this_closeButton_current;
                return (_this_closeButton = _this.closeButton) === null || _this_closeButton === void 0 ? void 0 : (_this_closeButton_current = _this_closeButton.current) === null || _this_closeButton_current === void 0 ? void 0 : _this_closeButton_current.focus();
            },
            className: "social-app-wrapper",
            noIsolation: true,
            autoFocus: true
        }, /*#__PURE__*/ React.createElement("button", {
            className: "close-btn",
            ref: this.closeButton,
            onClick: close,
            "aria-label": intl.formatMessage({
                id: "ui.close_dialog",
                defaultMessage: "Close dialog"
            })
        }, /*#__PURE__*/ React.createElement(Icon, {
            name: "close-socialmenu",
            size: "s"
        })), /*#__PURE__*/ React.createElement(SocialAppHeader, {
            hero: true
        }, /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
            className: "social-app-title",
            id: "bonus-material-header"
        }, intl.formatMessage({
            id: "bonus_material.title",
            defaultMessage: "Bonus Material"
        })), !currentOnly && /*#__PURE__*/ React.createElement(UIToggleButton, {
            id: "filter-bonus-material",
            onToggle: this._toggleNodeFilter,
            pressed: showFromAllCBook,
            label: intl.formatMessage({
                id: "social.activities._title_nodes_filter_label",
                defaultMessage: "Showing from: {currentFilter}"
            }, {
                currentFilter: currentFilter
            })
        }, /*#__PURE__*/ React.createElement(Icon, {
            name: showFromAllCBook ? "pages-all" : "page-current",
            size: "m"
        }), /*#__PURE__*/ React.createElement("span", {
            className: "ui-toggle-text"
        }, currentFilter)))), /*#__PURE__*/ React.createElement("div", {
            className: "social-app-body bonus-material"
        }, /*#__PURE__*/ React.createElement("ol", {
            className: "bonus-material__list"
        }, bonusMaterial.map(this.renderBonus)))))));
    };
    return BonusMaterialComponent;
}(PureComponent);
export default injectIntl(BonusMaterialComponent);
